module.exports = __webpack_public_path__ + "static/img/tb-user-circle.5e7557d5.svg";